import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import ar from './ar.json'
import en from './en.json'

const saved = typeof localStorage !== 'undefined' ? localStorage.getItem('sakk-lang') : null
const browserLang = navigator?.language?.startsWith('ar') ? 'ar' : 'en'
const detected = saved || browserLang

i18n.use(initReactI18next).init({
  resources: { ar: { translation: ar }, en: { translation: en } },
  lng: detected,
  fallbackLng: 'ar',
  interpolation: { escapeValue: false },
})

export function applyDir(lng: string) {
  const dir = lng === 'ar' ? 'rtl' : 'ltr'
  document.documentElement.dir = dir
  document.documentElement.lang = lng
}

applyDir(i18n.language)

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('sakk-lang', lng)
  applyDir(lng)
})

export default i18n
